// extracted by mini-css-extract-plugin
module.exports = {"root":"SubTabs_root__3V3Wx"};